/* tslint:disable */

import { ReaderFragment } from "relay-runtime";
import { FragmentRefs } from "relay-runtime";
export type TileTestVariant_item = {
    readonly serviceId: string | null;
    readonly title: string | null;
    readonly localizedPdpUrl: string | null;
    readonly classification: {
        readonly creationDate: string | null;
    } | null;
    readonly creators: ReadonlyArray<{
        readonly attribution: string | null;
        readonly creator: {
            readonly displayName: string | null;
        } | null;
    } | null> | null;
    readonly isArt: boolean | null;
    readonly seller?: {
        readonly serviceId: string | null;
        readonly sellerProfile: {
            readonly company: string | null;
        } | null;
    } | null;
    readonly " $fragmentRefs": FragmentRefs<"Shipping_item" | "SwatchSelectorMinimal_item" | "Product_item" | "Price_item" | "QuickViewItem_item" | "ProductTileMeasurements_item">;
    readonly " $refType": "TileTestVariant_item";
};
export type TileTestVariant_item$data = TileTestVariant_item;
export type TileTestVariant_item$key = {
    readonly " $data"?: TileTestVariant_item$data;
    readonly " $fragmentRefs": FragmentRefs<"TileTestVariant_item">;
};



const node: ReaderFragment = (function(){
var v0 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "serviceId",
  "args": null,
  "storageKey": null
};
return {
  "kind": "Fragment",
  "name": "TileTestVariant_item",
  "type": "Item",
  "metadata": null,
  "argumentDefinitions": [
    {
      "kind": "LocalArgument",
      "name": "isTrade",
      "type": "Boolean",
      "defaultValue": false
    },
    {
      "kind": "LocalArgument",
      "name": "showSeller",
      "type": "Boolean",
      "defaultValue": false
    },
    {
      "kind": "LocalArgument",
      "name": "pageDisplayEnum",
      "type": "PageDisplayEnum",
      "defaultValue": "searchAndBrowse"
    }
  ],
  "selections": [
    (v0/*: any*/),
    {
      "kind": "ScalarField",
      "alias": null,
      "name": "title",
      "args": null,
      "storageKey": null
    },
    {
      "kind": "ScalarField",
      "alias": null,
      "name": "localizedPdpUrl",
      "args": null,
      "storageKey": null
    },
    {
      "kind": "LinkedField",
      "alias": null,
      "name": "classification",
      "storageKey": null,
      "args": null,
      "concreteType": "ItemClassification",
      "plural": false,
      "selections": [
        {
          "kind": "ScalarField",
          "alias": null,
          "name": "creationDate",
          "args": null,
          "storageKey": null
        }
      ]
    },
    {
      "kind": "LinkedField",
      "alias": null,
      "name": "creators",
      "storageKey": null,
      "args": null,
      "concreteType": "ItemCreator",
      "plural": true,
      "selections": [
        {
          "kind": "ScalarField",
          "alias": null,
          "name": "attribution",
          "args": null,
          "storageKey": null
        },
        {
          "kind": "LinkedField",
          "alias": null,
          "name": "creator",
          "storageKey": null,
          "args": null,
          "concreteType": "Creator",
          "plural": false,
          "selections": [
            {
              "kind": "ScalarField",
              "alias": null,
              "name": "displayName",
              "args": null,
              "storageKey": null
            }
          ]
        }
      ]
    },
    {
      "kind": "ScalarField",
      "alias": null,
      "name": "isArt",
      "args": null,
      "storageKey": null
    },
    {
      "kind": "Condition",
      "passingValue": true,
      "condition": "showSeller",
      "selections": [
        {
          "kind": "LinkedField",
          "alias": null,
          "name": "seller",
          "storageKey": null,
          "args": null,
          "concreteType": "Seller",
          "plural": false,
          "selections": [
            (v0/*: any*/),
            {
              "kind": "LinkedField",
              "alias": null,
              "name": "sellerProfile",
              "storageKey": null,
              "args": null,
              "concreteType": "SellerProfile",
              "plural": false,
              "selections": [
                {
                  "kind": "ScalarField",
                  "alias": null,
                  "name": "company",
                  "args": null,
                  "storageKey": null
                }
              ]
            }
          ]
        }
      ]
    },
    {
      "kind": "FragmentSpread",
      "name": "Shipping_item",
      "args": null
    },
    {
      "kind": "FragmentSpread",
      "name": "SwatchSelectorMinimal_item",
      "args": null
    },
    {
      "kind": "FragmentSpread",
      "name": "Product_item",
      "args": null
    },
    {
      "kind": "FragmentSpread",
      "name": "Price_item",
      "args": [
        {
          "kind": "Variable",
          "name": "isTrade",
          "variableName": "isTrade"
        },
        {
          "kind": "Variable",
          "name": "pageDisplayEnum",
          "variableName": "pageDisplayEnum"
        }
      ]
    },
    {
      "kind": "FragmentSpread",
      "name": "QuickViewItem_item",
      "args": null
    },
    {
      "kind": "FragmentSpread",
      "name": "ProductTileMeasurements_item",
      "args": null
    }
  ]
};
})();
(node as any).hash = 'b945b79309351aa16acc11376a162948';
export default node;
